import { Widget } from '@framework/engine';
import {
  ContentWrapper,
  FormComponent,
  WidgetContainerWrapper,
} from '@framework/engine-ui';
import React from 'react';
import { isContainer } from '../../widgets/repository/containers/IContainerWidget';
import { FillableWidgetList } from './FillableWidgetList';

export interface IFillableWidgetProps {
  widget: Widget;
  parent: Widget | undefined;
  readonly?: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Componente che gestisce la rappresentazione di un widget.
 * Come il componente SortableWidgetRender, ma senza la possibilità di essere trascinato,
 * e contenente un input compilabile e funzionante.
 */
export function FillableWidget(props: IFillableWidgetProps) {
  const { widget, readonly, isReadonly } = props;
  const isWidgetReadonly = Boolean(readonly) || isReadonly?.(widget);

  return (
    <WidgetContainerWrapper>
      <ContentWrapper className="fillable-widget-wrapper">
        {isContainer(widget) ? (
          <FormComponent widget={widget} readonly={isWidgetReadonly}>
            <FillableWidgetList
              widgets={widget.children ?? []}
              parent={widget}
              readonly={readonly}
              isReadonly={isReadonly}
            />
          </FormComponent>
        ) : (
          <FormComponent widget={widget} readonly={isWidgetReadonly} />
        )}
      </ContentWrapper>
    </WidgetContainerWrapper>
  );
}
